export default function Icon3() {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.75 10.8333C8.75 9.68274 9.68274 8.75 10.8333 8.75H40C41.1506 8.75 42.0833 9.68274 42.0833 10.8333V40C42.0833 41.1506 41.1506 42.0833 40 42.0833H10.8333C9.68274 42.0833 8.75 41.1506 8.75 40V10.8333Z"
                stroke="currentColor"
                stroke-width="1.875"
            />
            <path
                d="M21.4997 22.227C20.114 20.8415 17.8888 20.8384 16.53 22.1973C15.1714 23.5562 15.1749 25.7807 16.5603 27.1664C17.9443 28.5503 20.1652 28.5554 21.5246 27.2016L22.4589 26.23L23.5403 27.2699L22.6018 28.247L22.5908 28.2581C20.636 30.2125 17.461 30.1884 15.4997 28.227C13.5386 26.2657 13.5149 23.0913 15.4693 21.1366C17.424 19.1819 20.5989 19.2051 22.5604 21.1663L26.1967 24.8027L25.1361 25.8633L21.4997 22.227Z"
                fill="currentColor"
            />
            <path
                d="M28.5002 27.1063C29.8859 28.4918 32.1111 28.4948 33.4699 27.136C34.8285 25.7771 34.8249 23.5525 33.4395 22.1669C32.0539 20.7813 29.8288 20.7772 28.4698 22.1358L28.456 22.1496L27.5168 23.0432L26.4831 21.957L27.4098 21.0759C29.3646 19.1214 32.5389 19.1449 34.5002 21.1062C36.4613 23.0676 36.4849 26.2419 34.5306 28.1966C32.5759 30.1513 29.401 30.1282 27.4395 28.1669L23.8031 24.5306L24.8638 23.4699L28.5002 27.1063Z"
                fill="currentColor"
            />
        </svg>
    );
}
